/**
 * The elements a habitat onboarding step can highlight. Each value is the `data-tour-target`
 * attribute carried by the component(s) that render the control.
 *
 * Several elements may share one name: `CAPTURE` is on the snapshot, clip and react buttons, so
 * the capture step lights all three at once. The attribute lives on the primitive components rather
 * than their parents because the stream controls render from three different places
 * (DesktopControlBar, StreamControls, MobileControls).
 */
export const TOUR_TARGETS = {
  ZOOM: 'zoom',
  PAN: 'pan',
  CAPTURE: 'capture',
  CAMERA_SWITCH: 'camera-switch',
  ACTIVITY_FEED: 'activity-feed',
  // The tab bar highlights only its Meet+Watch run, and does so with a measured overlay ring
  // inside HabitatTabs rather than a box-shadow on the element — the bar overflows its container,
  // which clipped an on-element ring. Its `data-tour-target` is still used for scroll-into-view.
  HABITAT_TABS: 'habitat-tabs',
  FOLLOW: 'follow',
} as const;

export type TourTarget = (typeof TOUR_TARGETS)[keyof typeof TOUR_TARGETS];
